const assassin = require('./Assassin');
const battle_mage = require('./BattleMage');
const dreamsmith = require('./Dreamsmith');
const invoker = require('./Invoker');
const knight = require('./Knight');
const mercenary = require('./Mercenary');
const monk = require('./Monk');
const paladin = require('./Paladin');
const ranger = require('./Ranger');
const shaman = require('./Shaman');
const warlock = require('./Warlock');

const heroes = {
  assassin,
  battle_mage,
  dreamsmith,
  invoker,
  knight,
  mercenary,
  monk,
  paladin,
  ranger,
  shaman,
  warlock,
};
module.exports = heroes;
